import { CallStage, CallStateConsumer } from 'app/containers/call/CallStateContext';
import { BookingStateConsumer } from 'app/containers/rtc/BookingContext/BookingState';
import { BookingState } from 'app/models/rtc/booking/constants';
import React, { Component, FunctionComponent, ReactNode } from 'react';
import { createSelector } from 'reselect';

export interface ICallVideoState {
  /**
   * Show video elements
   */
  readonly showVideoUI: boolean;
  /**
   * Enable local video devices
   */
  readonly enableDevices: boolean;
}

interface IProps {
  readonly children: (videoState: ICallVideoState) => ReactNode;
}

interface IDeps {
  bookingState?: BookingState;
  callStage: CallStage;
}

class CallVideoStateRender extends Component<IProps & IDeps> {
  private readonly getVideoState = createSelector(
    ({ bookingState }: IDeps) => bookingState,
    ({ callStage }: IDeps) => callStage,
    calcVideoState,
  );

  public render() {
    return this.props.children(this.getVideoState(this.props));
  }
}

export const calcVideoState = (
  bookingState: BookingState | undefined,
  callStage: CallStage,
): ICallVideoState => {
  const videoEnabledInCallState = (
    callStage === CallStage.Active
  );

  const beforeFinalLock = (
    callStage === CallStage.Unknown ||
    callStage === CallStage.AwaitingActivation ||
    callStage === CallStage.Active
  );

  return {
    showVideoUI: beforeFinalLock && Boolean(bookingState),
    enableDevices: Boolean(bookingState) && videoEnabledInCallState,
  };
};

export const CallVideoStateConsumer: FunctionComponent<IProps> = (props) => (
  <BookingStateConsumer>{(bookingState) =>
    <CallStateConsumer>{({ stage }) =>
      <CallVideoStateRender
        bookingState={bookingState}
        callStage={stage}
        {...props}
      />
    }</CallStateConsumer>
  }</BookingStateConsumer>
);
